<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
    <button class="cursor-pointer text-secondary" @click="$router.back()">
        <i class="fa-regular fa-arrow-left fa-2xl"></i>
    </button>
</template>

<script>
export default {
    name: 'BackComponent'
};
</script>

<style scoped></style>
